export const CASES = {
    UPDATE_COMMENTS: 'UPDATE_COMMENTS',
    UPDATE_COMMENTS_FILTER_FORM: 'UPDATE_COMMENTS_FILTER_FORM',
    CLEAR_COMMENTS: 'CLEAR_COMMENTS',
};
